import { render } from "./GoalInfoPanel.vue?vue&type=template&id=c447b3c8&scoped=true"
import script from "./GoalInfoPanel.vue?vue&type=script&lang=js"
export * from "./GoalInfoPanel.vue?vue&type=script&lang=js"

import "./GoalInfoPanel.vue?vue&type=style&index=0&id=c447b3c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c447b3c8"]])

export default __exports__